import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Message } from 'primeng/api';
import { forkJoin } from 'rxjs';

import moment from 'moment';

import { Estado } from 'src/app/models/estado.interface';
import { Institucion } from 'src/app/models/institucion.interface';
import { TipoDropdown } from 'src/app/models/tipo-dropdown.interface';
import { MedicoService } from 'src/app/services/medico.service';
import { Hospital } from 'src/app/models/hospital.interface';
import { Catalogo, TipoSexo } from 'src/app/models/catalogos.interface';
import { Producto } from 'src/app/models/producto.interface';
import { DIA, DIAS_PLAZO, NUMERO_MiN_DIAS, SEXO } from 'src/app/shared/constantes/constants';
import { AsignacionCodigosAlCasoClinicos, CasoClinico, Cirugia, Ficha, Folio } from 'src/app/models/caso-clinico.interface';
import { DocumentoCasoClinico } from 'src/app/models/documento-caso-clinico.interface';
import { AuthService } from 'src/app/services/auth.service';
import { FechasCasoClinco } from 'src/app/models/fechas-caso-clinico';
import { FileUploadComponent } from 'src/app/pages/components/file-upload/file-upload.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-medico-casoclinico',
  templateUrl: './medico-casoclinico.component.html',
  styleUrls: ['./medico-casoclinico.component.scss'],
  providers: [ConfirmationService, FileUploadComponent]
})
export class MedicoCasoclinicoComponent implements OnInit {
  // @ViewChild('fileUploadControl')  public fileUploadControl: any;

  readonly urlbase: string = environment.urlbase;
  readonly uri: string = "docscasosclinicos/";

  idCasoClinico: string = '0';
  folio!: Folio;
  uploadedFiles: any[] = [];

  //fechaFichaActual!: Date;
  fechaCirugiaMaxHoy!: Date;
  fechaCirugiaMinHoy!: Date;
  fechasDelCasoClinico!: FechasCasoClinco;

  fechaHoy!: Date;
  fechaFicha!: Date;
  fechaFichaMax!: Date;

  diasTranscurridos!: number;
  diasPlazo!: number;

  fechaCirugiaMin!: Date;
  fechaCirugiaMax!: Date;

  casoclinico!: CasoClinico;
  fichaForm!: FormGroup;
  cirugiaForm!: FormGroup;
  codigoForm!: FormGroup;
  documentoForm!: FormGroup;

  tipoDropSexo: TipoDropdown[] = [];
  instituciones: TipoDropdown[] = [];
  estados: TipoDropdown[] = [];
  hospitales: TipoDropdown[] = [];
  diagnosticos: TipoDropdown[] = [];
  antibioticos: TipoDropdown[] = [];
  usosProducto: TipoDropdown[] = [];
  seccionesCuerpo: TipoDropdown[] = [];
  acciones: TipoDropdown[] = [];
  tiposDocumentos: TipoDropdown[] = []

  catalogoSexo: Catalogo[] = [...SEXO];
  productos: Producto[] = [];
  productosxAsignar: Producto[] = [];
  documentos: DocumentoCasoClinico[] = [];
  catalogoTipoSexo: TipoSexo[] = [...SEXO];

  messages: Message[] = [];
  message!: Message[];

  fechaFichaLabel: string = "";
  fechaCirugiaLabel: string | null = null;

  get isNuevo(): boolean {
    return this.idCasoClinico == '0';
  }
  get fichaFrm() {
    return this.fichaForm.controls;
  }
  get cirugiaFrm() {
    return this.cirugiaForm.controls;
  }
  get c() {
    return this.codigoForm.controls;
  }


  constructor(
    private authService: AuthService,
    private activedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private medicoService: MedicoService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    this.idCasoClinico = this.activedRoute.snapshot.params['id'];
    this.fechaHoy = new Date();

    //this.fechaFichaActual = new Date();

    this.fechaCirugiaMaxHoy = new Date();
    this.fechaCirugiaMinHoy = new Date();

    this.diasPlazo = DIAS_PLAZO;
    this.diasTranscurridos = 0;

    this.fechaCirugiaMax = new Date(this.fechaCirugiaMaxHoy.getTime()); //+ (DIA * DIAS_PLAZO));
    this.fechaCirugiaMin = new Date(this.fechaCirugiaMinHoy.getTime()); //- (DIA * NUMERO_MiN_DIAS));

    this.fichaForm = this.crearFormularioFicha();
    this.cirugiaForm = this.crearFormularioCirugia();
    this.codigoForm = this.crearFormularioCodigo();
    this.documentoForm = this.crearFormularioDocumento();

    this.obtenerInformacion(this.idCasoClinico, this.authService.getUsuario?.medico?.id);

    this.fullCatalogoSexo(this.catalogoSexo);
    this.confiChange();

    this.message = [{ severity: 'error', summary: '', detail: 'Se termino el plazo de registro de fecha de cirugia' }];
    this.messages = [{ severity: 'info', summary: 'Info', detail: 'Informacion del Caso Clinico' }]

  }

  ngOnInit(): void {
    this.fechaFichaMax = new Date(this.fechaHoy.getTime() + (DIA * 0));

  }

  crearFormularioFicha(): FormGroup {
    return this.formBuilder.group({
      folio: [''],
      serie: [''],
      paciente: [''],
      sexo: ['', Validators.required],
      edad: ['', Validators.required],
      fecha: ['', Validators.required],
      fk_estado: ['', Validators.required],
      fk_institucion: ['', Validators.required],
      otracveInstitucion: [''],
      fk_hospital: ['', Validators.required],
      otrohospital: [''],
      fk_diagnostico: ['', Validators.required],
      otrodiagnostico: [''],
      antecedente: ['']
    });
  }

  crearFormularioCirugia(): FormGroup {
    return this.formBuilder.group({
      fk_seccion_cuerpo: ['', Validators.required],
      acciones: [[], Validators.required],
      fk_usoProducto: ['', Validators.required],
      fk_antibiotico1: [''],
      cantidad1: [''],
      fk_antibiotico2: [''],
      cantidad2: [''],
      fk_antibiotico3: [''],
      cantidad3: [''],
      tratamiento: ['', Validators.required],
      fechaAplicacionProducto: ['', Validators.required],
      observacion: [''],

    });
  }

  crearFormularioCodigo(): FormGroup {
    return this.formBuilder.group({
      codigo: ['', Validators.required]
    })
  }

  crearFormularioDocumento(): FormGroup {
    return this.formBuilder.group({
      fk_tipoDocumento: [''],
      descDocumento: ['']
    })
  }

  obtenerInformacion(idCasoClinico: string, idMedico: number | undefined): void {
    if (idCasoClinico === '0') {
      this.obtenerInformacionNuevo(idMedico, idCasoClinico);
    } else {
      this.obtenerInformacionActualizar(idCasoClinico);
    }
  }

  obtenerInformacionNuevo(idMedico: number | undefined, idCasoClinico: string): void {
    if (idMedico) {
      this.cargarDatosSin(idMedico.toString(), idCasoClinico);
    }
  }

  obtenerInformacionActualizar(idCasoClinico: string): void {
    this.cargarDatosCon(idCasoClinico);
  }

  cargarDatosSin(idMedico: string, idCasoClinico: string): void {
    forkJoin({
      subFechas: this.medicoService.getFechasCasoClinico(idCasoClinico),
      subFolio: this.medicoService.getFolioNuevo(idMedico),
      subInstituciones: this.medicoService.getInstituciones(),
      subEstados: this.medicoService.getEstados(),
      subDiagnosticos: this.medicoService.getDiagnosticos(),
      subAntibioticos: this.medicoService.getAntibioticos(),
      subSeccionesCuerpo: this.medicoService.getSeccionCuerpo(),
      subUsosProducto: this.medicoService.getUsosProducto(),
      subAcciones: this.medicoService.getAcciones(),
      subTiposDocumentos: this.medicoService.getTiposDocumentos()
    }).subscribe({
      next: (resp) => {
        this.fullFechasCasosClinicos(resp.subFechas.datos);
        this.fullCatalogoInstituciones(resp.subInstituciones);
        this.fullCatalogoEstados(resp.subEstados);
        this.fullCatalogoDiagnosticos(resp.subDiagnosticos);
        this.fullCatalogoAntibioticos(resp.subAntibioticos);
        this.fullCatalogoSecciones(resp.subSeccionesCuerpo);
        this.fullCatalogoUsosProducto(resp.subUsosProducto);
        this.fullCatalogoAcciones(resp.subAcciones);
        this.fullCatalogoTiposDocumentos(resp.subTiposDocumentos);
        this.fullFormFolioNuevo(resp.subFolio.datos);


      },
      error: (err) => { console.log(err) }
    });
  }

  cargarDatosCon(id: string): void {

    forkJoin({
      subFechas: this.medicoService.getFechasCasoClinico(id),
      subInstituciones: this.medicoService.getInstituciones(),
      subEstados: this.medicoService.getEstados(),
      subDiagnosticos: this.medicoService.getDiagnosticos(),
      subAntibioticos: this.medicoService.getAntibioticos(),
      subSeccionesCuerpo: this.medicoService.getSeccionCuerpo(),
      subUsosProducto: this.medicoService.getUsosProducto(),
      subAcciones: this.medicoService.getAcciones(),
      subTiposDocumentos: this.medicoService.getTiposDocumentos(),
      subCasoClinico: this.medicoService.getCasoClinico(id)
    }).subscribe({
      next: (resp) => {
        this.fullFechasCasosClinicos(resp.subFechas.datos);
        this.fullCatalogoInstituciones(resp.subInstituciones);
        this.fullCatalogoEstados(resp.subEstados);
        this.fullCatalogoDiagnosticos(resp.subDiagnosticos);
        this.fullCatalogoAntibioticos(resp.subAntibioticos);
        this.fullCatalogoSecciones(resp.subSeccionesCuerpo);
        this.fullCatalogoUsosProducto(resp.subUsosProducto);
        this.fullCatalogoAcciones(resp.subAcciones);
        this.fullCatalogoTiposDocumentos(resp.subTiposDocumentos);
        this.fullCasoClinico(resp.subCasoClinico.datos);
      },
      error: (err) => { console.log(err) }
    });

  }

  fullCasoClinico(casoclinico: CasoClinico): void {
    this.fichaFrm['folio'].setValue(casoclinico.folio);
    this.fichaFrm['serie'].setValue(casoclinico.serie);
    this.fichaFrm['paciente'].setValue(casoclinico.paciente);
    this.fichaFrm['sexo'].setValue(this.seTipoSexo(casoclinico.sexo));
    this.fichaFrm['edad'].setValue(casoclinico.edad);
    this.fichaFrm['fecha'].setValue(casoclinico.fecha);
    this.fichaFrm['fk_estado'].setValue(casoclinico.fk_estado.toString());
    this.fichaFrm['fk_institucion'].setValue(casoclinico.fk_institucion.toString());
    this.fichaFrm['fk_hospital'].setValue(casoclinico.fk_hospital.toString());
    this.fichaFrm['fk_diagnostico'].setValue(casoclinico.fk_diagnostico.toString());
    this.fichaFrm['antecedente'].setValue(casoclinico.antecedente);

    const fecha = new DatePipe("en-US");
    this.fechaFichaLabel = <string>fecha.transform(this.fichaFrm['fecha'].value, 'dd/MM/yyyy')?.toString();

    //seccion cirugia
    if (casoclinico.fechaAplicacionProducto) {

      this.cirugiaFrm['fechaAplicacionProducto'].setValue(casoclinico.fechaAplicacionProducto);
      this.fechaCirugiaLabel = <string>fecha.transform(this.cirugiaFrm['fechaAplicacionProducto'].value, 'dd/MM/yyyy')?.toString();
    }

    const accionesCtrl: string[] = casoclinico.acciones.length > 0 ? casoclinico.acciones.map(item => item.id.toString()) : [];
    this.cirugiaFrm['acciones'].setValue(accionesCtrl);

    const fk_seccion_cuerpo_ctrl: string = casoclinico.fk_seccion_cuerpo ? casoclinico.fk_seccion_cuerpo.toString() : '';
    this.cirugiaFrm['fk_seccion_cuerpo'].setValue(fk_seccion_cuerpo_ctrl);

    const tratamientoCtrl: string = casoclinico.tratamiento ? casoclinico.tratamiento : '';
    this.cirugiaFrm['tratamiento'].setValue(tratamientoCtrl);

    const usoProductoCtrl: string = casoclinico.usosproducto.length > 0 ? casoclinico.usosproducto[0].id.toString() : '';
    this.cirugiaFrm['fk_usoProducto'].setValue(usoProductoCtrl);

    const antibicotico1Ctrl: string = casoclinico.fk_antibiotico1 ? casoclinico.fk_antibiotico1.toString() : '';
    this.cirugiaFrm['fk_antibiotico1'].setValue(antibicotico1Ctrl);
    const cantidad1Ctrl: number = casoclinico.cantidad1 ? casoclinico.cantidad1 : 0;
    this.cirugiaFrm['cantidad1'].setValue(cantidad1Ctrl);

    const antibicotico2Ctrl: string = casoclinico.fk_antibiotico2 ? casoclinico.fk_antibiotico2.toString() : '';
    this.cirugiaFrm['fk_antibiotico2'].setValue(antibicotico2Ctrl);
    const cantidad2Ctrl: number = casoclinico.cantidad2 ? casoclinico.cantidad2 : 0;
    this.cirugiaFrm['cantidad2'].setValue(cantidad2Ctrl);

    const antibicotico3Ctrl: string = casoclinico.fk_antibiotico3 ? casoclinico.fk_antibiotico3.toString() : '';
    this.cirugiaFrm['fk_antibiotico3'].setValue(antibicotico3Ctrl);
    const cantidad3Ctrl: number = casoclinico.cantidad3 ? casoclinico.cantidad3 : 0;
    this.cirugiaFrm['cantidad3'].setValue(cantidad3Ctrl);

    const observacionesCtrl: string = casoclinico.observacion ? casoclinico.observacion : '';
    this.cirugiaFrm['observacion'].setValue(observacionesCtrl);

    this.productos.push(...casoclinico.productos);
    this.documentos.push(...casoclinico.documentos);
  }

  fullFormFolioNuevo(folio: Folio): void {
    this.fichaFrm['folio'].setValue(folio.folio);
    this.fichaFrm['serie'].setValue(folio.serie);
  }

  fullFechasCasosClinicos(fechas: FechasCasoClinco): void {
    this.fechasDelCasoClinico = fechas;

    this.fechaHoy = new Date(fechas.fechaHoy);
    this.fechaCirugiaMaxHoy = new Date(fechas.fechaCirugiaMax);

    this.diasPlazo = fechas.diasPlazo;
    this.diasTranscurridos = fechas.diasTranscurridos;

    let fCirugiaMax = moment(fechas.fechaCirugiaMax);
    let fCirugiaMin = moment(fechas.fechaCirugiaMin);
    this.fechaCirugiaMax = new Date(fCirugiaMax.format());
    this.fechaCirugiaMin = new Date(fCirugiaMin.format());


    if (this.fechaCirugiaLabel == null) {
      if (this.diasPlazo == this.diasTranscurridos) {
        this.messages.push({ severity: 'warn', summary: '', detail: 'Hoy es el ultimo dia' });
      }
      const mensaje = `Dias trascurridos ${fechas.diasTranscurridos}, de un plazo de ${fechas.diasPlazo} dias`;
      this.messages.push({ severity: 'info', summary: 'Info', detail: mensaje });
    }
  }

  fullCatalogoInstituciones(instituciones: Institucion[]): void {
    const items: TipoDropdown[] = [...instituciones.map((item: Institucion) => this.institucionToTipoDropdown(item))];
    this.instituciones.push(...items);
  }

  fullCatalogoEstados(estados: Estado[]): void {
    const items: TipoDropdown[] = [...estados.map((item: Estado) => this.estadoToTipoDropdown(item))];
    this.estados.push(...items);
  }

  fullCatalogoDiagnosticos(catalogo: Catalogo[]): void {
    const items: TipoDropdown[] = [...catalogo.map((item: Catalogo) => this.catalogoToTipoDropdown(item))];
    this.diagnosticos.push(...items);
  }

  fullCatalogoAntibioticos(catalogo: Catalogo[]): void {
    const items: TipoDropdown[] = [...catalogo.map((item: Catalogo) => this.catalogoToTipoDropdown(item))];
    this.antibioticos.push(...items);
  }

  fullCatalogoUsosProducto(catalogo: Catalogo[]): void {
    const items: TipoDropdown[] = [...catalogo.map((item: Catalogo) => this.catalogoToTipoDropdown(item))];
    this.usosProducto.push(...items);
  }

  fullCatalogoSecciones(catalogo: Catalogo[]): void {
    const items: TipoDropdown[] = [...catalogo.map((item: Catalogo) => this.catalogoToTipoDropdown(item))];
    this.seccionesCuerpo.push(...items);
  }
  fullCatalogoAcciones(catalogo: Catalogo[]): void {
    const items: TipoDropdown[] = [...catalogo.map((item: Catalogo) => this.catalogoToTipoDropdown(item))];
    this.acciones.push(...items);
  }
  fullCatalogoTiposDocumentos(catalogo: Catalogo[]): void {
    const items: TipoDropdown[] = [...catalogo.map((item: Catalogo) => this.catalogoToTipoDropdown(item))];
    this.tiposDocumentos.push(...items);
  }
  fullCatalogoSexo(catalogo: Catalogo[]): void {
    const items: TipoDropdown[] = [...catalogo.map((item: Catalogo) => this.catalogoToTipoDropdown(item))];
    this.tipoDropSexo.push(...items);
  }
  fullCatalogoHospital(hospitales: Hospital[]): void {
    this.hospitales = [];
    const items: TipoDropdown[] = [...hospitales.map((item: Hospital) => this.hospitalToTipoDropdown(item))];
    this.hospitales.push(...items);
  }
  institucionToTipoDropdown(institucion: Institucion): TipoDropdown {
    return { value: `${institucion.id}`, label: institucion.cvInstitucion };
  }
  estadoToTipoDropdown(estado: Estado): TipoDropdown {
    return { value: `${estado.id}`, label: estado.nomEstado };
  }
  hospitalToTipoDropdown(hospital: Hospital): TipoDropdown {
    return { value: `${hospital.id}`, label: hospital.nomHospital };
  }
  catalogoToTipoDropdown(catalogo: Catalogo): TipoDropdown {
    return { value: `${catalogo.id}`, label: catalogo.descripcion };
  }

  confiChange(): void {
    this.fichaForm.get('fk_estado')?.valueChanges.subscribe((value) => { this.getHospitales(); });
    this.fichaForm.get('fk_institucion')?.valueChanges.subscribe((value) => { this.getHospitales(); });
  }

  getHospitales(): void {
    const idInstitucion: number = this.fichaForm.get('fk_institucion')?.value;
    const idEstado: number = this.fichaForm.get('fk_estado')?.value;

    if (idInstitucion && idEstado) {
      this.medicoService.getHospitales(idInstitucion, idEstado).subscribe({
        next: (resp) => {
          this.fullCatalogoHospital(resp);
        },
        error: (err) => { console.log(err) }
      });
    }
  }

  getCodigo(): void {
    const codigo = this.codigoForm.get('codigo')?.value;
    if (codigo) {
      this.medicoService.getCodigo(codigo).subscribe({
        next: (resp) => {
          this.showSuccess(resp.mensaje);
          this.productosxAsignar.push(resp.datos);
          this.c['codigo'].reset();
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err.error.message);
          console.error(err.error.message)
        }
      });
    } else {
      this.showError("Ingrese el Codigo");
    }
  }

  asignarCodigos(): void {
    const ids: number[] = this.productosxAsignar.map(item => item.id);
    const asignar: AsignacionCodigosAlCasoClinicos = { idsCodigos: ids, idCasoClinico: this.idCasoClinico };

    this.medicoService.asignarCodigosCasoClinico(asignar)
      .subscribe({
        next: (resp) => { this.procesarAsignacion(resp.datos.productos); this.showSuccess(resp.mensaje); },
        error: (err: HttpErrorResponse) => { this.showError(err.error.message), console.log(err); }
      })

  }

  procesarAsignacion(productos: Producto[]) {
    this.productos = [];
    this.productos.push(...productos);
  }

  guardarFicha(): void {
    const ficha: Ficha = this.fichaForm.value;

    const idSexo: string = ficha.sexo;
    const idMedico = this.authService.getUsuario?.medico?.id;
    const fecha = new DatePipe("en-US");

    ficha.fecha = <string>fecha.transform(this.fichaFrm['fecha'].value, 'yyyy-MM-dd')?.toString();
    ficha.sexo = this.getTipoSexo(idSexo);

    if (idMedico) {
      ficha.fk_medico = idMedico;
      this.medicoService.setCasoClinicoFichaNuevo(ficha).subscribe({
        next: (resp) => {
          this.idCasoClinico = resp.datos.id.toString();
          this.fechaFichaLabel = <string>fecha.transform(this.fichaFrm['fecha'].value, 'dd/MM/yyyy')?.toString();
          this.showSuccess(resp.mensaje);
        },
        error: (err: HttpErrorResponse) => { this.showError(err.error.message), console.log(err) }
      });
    }

  }

  actualizarFicha(): void {
    const ficha: Ficha = this.fichaForm.value;
    const idMedico = this.authService.getUsuario?.medico?.id;

    const idSexo: string = ficha.sexo;
    const fecha = new DatePipe("en-US");

    ficha.fecha = <string>fecha.transform(this.fichaFrm['fecha'].value, 'yyyy-MM-dd')?.toString();
    ficha.sexo = this.getTipoSexo(idSexo);

    if (idMedico) this.medicoService
      .setCasoClinicoFichaActualizar(ficha, this.idCasoClinico)
      .subscribe({
        next: (resp) => {
          this.fechaFichaLabel = <string>fecha.transform(this.fichaFrm['fecha'].value, 'dd/MM/yyyy')?.toString();
          this.showSuccess(resp.mensaje);
        },
        error: (err: HttpErrorResponse) => { this.showError(err.error.message) }
      });

  }

  actualizarCirugia(): void {
    const cirugia: Cirugia = this.cirugiaForm.value;
    const idMedico = this.authService.getUsuario?.medico?.id;
    const fechaAplicacion = new DatePipe("en-US");
    cirugia.fechaAplicacionProducto = <string>fechaAplicacion.transform(this.cirugiaFrm['fechaAplicacionProducto'].value, 'yyyy-MM-dd')?.toString();

    if (idMedico) this.medicoService
      .setCasoClinicoCirugiaActualizar(cirugia, this.idCasoClinico)
      .subscribe({
        next: (resp) => {
          this.fechaCirugiaLabel = <string>fechaAplicacion.transform(this.cirugiaFrm['fechaAplicacionProducto'].value, 'dd/MM/yyyy')?.toString();
          this.showSuccess(resp.mensaje);
        },
        error: (err: HttpErrorResponse) => { this.showError(err.error.message) }
      });

  }

  onFileUploaded(file: File): void {
    this.subirDocumento(file);
  }

  subirDocumento(file: File): void {
    const formData = new FormData();
    const tipoDocumento = this.documentoForm.get('fk_tipoDocumento')?.value;
    const descDocumento = this.documentoForm.get('descDocumento')?.value;

    if (!tipoDocumento) {
      this.showError("El tipo del documento es requerido");
      return;
    }

    if (!descDocumento) {
      this.showError("La descripcion de documento es requerida");
      return;
    }

    formData.append("documento", file);
    formData.append("fk_casoClinico", this.idCasoClinico);
    formData.append("fk_tipoDocumento", tipoDocumento);
    formData.append("descDocumento", descDocumento);

    this.medicoService.subirDocumento(formData).subscribe({
      next: (resp) => {
        this.showSuccess(resp.mensaje);
        this.documentos.push(resp.datos);
        this.documentoForm.reset();
      },
      error: (err: HttpErrorResponse) => { this.showError(err.error.message); console.log(err) }
    })
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: mensaje, life: 3000 });
  }

  showError(mensaje: string): void {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: mensaje });
  }

  seTipoSexo(abr: string): string {
    const idSexo: number | undefined = this.catalogoTipoSexo.find((item) => item.abr == abr)?.id;
    return idSexo ? idSexo.toString() : '';
  }

  getTipoSexo(id: string): string {
    const abr: string | undefined = this.catalogoTipoSexo.find((item) => item.id.toString() === id)?.abr;
    return abr ? abr : '';
  }

  asignarCodigo(): void {
    const codigo = this.codigoForm.get('codigo')?.value;
    const fk_casoClinico = 95; //const fk_casoClinico = 2975;
    if (codigo) {
      this.medicoService.setAsignarCodigo(codigo, fk_casoClinico)
        .subscribe({
          next: (resp) => {
            this.showSuccess("Asignacion de codigo exitoso")
            this.casoclinico = resp;
            this.procesarAsignacion(resp.productos)
          },
          error: (err: HttpErrorResponse) => { this.showError(err.error.message); }
        });

    } else {
      this.showError("Ingrese el Codigo");
    }
  }

  getFechasCasosClinicos(id: string): void {
    this.medicoService
      .getFechasCasoClinico(id)
      .subscribe({
        next: (resp) => { this.fullFechasCasosClinicos(resp.datos); },
        error: (err: HttpErrorResponse) => { console.log(err.error.messaage); }
      });
  }

  deleteSelectedDocumentos(id: number): void {
    this.confirmationService.confirm({
      message: 'Estas seguro de quitar el documento?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.medicoService.elimiarDocumento(id)
          .subscribe({
            next: (resp) => {
              this.documentos = resp.datos;
              this.showSuccess('Documento/Archivo descartado ');
            },
            error: (err: HttpErrorResponse) => { this.showError(err.error.message); console.log(err); }
          })

      }
    });
  }

  /*
onUpload(event: any) {
 for(let file of event.files) {
     this.uploadedFiles.push(file);
 }
}
uploadHandler(event: any): void{
  this.subirImage(event.files, event);
}
removeFile(event: any): void{
 const control: FileUpload = this.fileUploadControl as FileUpload;
 control.remove(event, 0);
}
subirImage(files: File[], evento: Event): void{
 if (files.length === 0) return;
 const control: FileUpload = this.fileUploadControl as FileUpload;
 const formData = new FormData();
 formData.append("documento", files[0]);
 formData.append("fk_casoClinico", this.idCasoClinico);
 formData.append("fk_tipoDocumento", "2");
 formData.append("descDocumento", "Rx postquirugico");
 this.medicoService.subirDocumento(formData).subscribe({
   next: (resp)=> {
     this.showSuccess(resp.mensaje);
     this.documentos.push(resp.datos); 
     control.remove(evento, 0);       
     console.log(control.files.length);
   },
   error: (err)=> {console.log(err)}
 })
}
*/
}
